import { AnimatePresence } from "framer-motion";
import { Dispatch, SetStateAction, useState } from "react";
import { createContext } from "react";
import { motion } from "framer-motion";
import InstagramPost from "../InstagramPost/InstagramPost.client";
import { useContext } from "react";
import { ReactNode } from "react";

type InstagramContextType = {
	posts: string[];
	setActiveSlide: Dispatch<SetStateAction<number | null>>;
};
const InstagramContext = createContext({} as InstagramContextType);

export const useInstagram = () => useContext(InstagramContext);

type Props = {
	children: ReactNode;
};
const InstagramSlider = (props: Props) => {
	const [activeSlide, setActiveSlide] = useState<number | null>(null);

	const posts = [
		"/instagram-images/instagram-image-1.jpeg",
		"/instagram-images/instagram-image-2.jpeg",
		"/instagram-images/instagram-image-3.jpeg",
		"/instagram-images/instagram-image-4.jpeg",
		"/instagram-images/instagram-image-5.jpeg",
		"/instagram-images/instagram-image-6.jpeg",
		"/instagram-images/instagram-image-7.jpeg",
		"/instagram-images/instagram-image-8.jpeg",
	];

	return (
		<InstagramContext.Provider value={{ posts, setActiveSlide }}>
			<AnimatePresence>
				{activeSlide !== null ? (
					<motion.div
						layout
						className="fixed inset-0 z-[9999] h-full w-full"
					>
						<motion.div
							layout
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							initial={{ opacity: 0 }}
							onClick={() => setActiveSlide(null)}
							className="absolute inset-0 bg-black bg-opacity-70"
						></motion.div>
						<div className="absolute top-1/2 left-1/2 h-full max-h-[90vmin] w-full max-w-[90vmin] -translate-x-1/2 -translate-y-1/2">
							<InstagramPost
								index={activeSlide}
								setActiveSlide={setActiveSlide}
								src={posts[activeSlide]}
							/>
						</div>
					</motion.div>
				) : null}
			</AnimatePresence>
			{props.children}
		</InstagramContext.Provider>
	);
};
export default InstagramSlider;
